import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import HeaderV2 from '../components/HeaderV2';
import FooterV2 from '../components/FooterV2';
import FunctionalHeroV2 from '../components/FunctionalHeroV2';
import FAQPage from './FAQPage';

/**
 * FAQV2Page
 * Barista Map 風格 V2 殼：HeaderV2 + 完整 Hero（深色滿版 + 大字）+ 奶油色文件區包裹 FAQPage + FooterV2
 * 對應路由：/zh/faq/v2、/en/faq/v2
 */
export default function FAQV2Page() {
  const location = useLocation();
  const isEn = location.pathname.startsWith('/en');
  const lang = isEn ? 'en' : 'zh';
  const canonicalUrl = `https://www.ongucoffee.com/${lang}/faq`;
  const isPreviewRoute = location.pathname.includes('/v2');

  useEffect(() => {
    const fontId = 'v2-fonts-faq';
    if (!document.getElementById(fontId)) {
      const link = document.createElement('link');
      link.id = fontId;
      link.rel = 'stylesheet';
      link.href =
        'https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;1,400&family=Noto+Serif+TC:wght@300;400;500&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  return (
    <>
      {/* /v2 預覽路由才 noindex；換骨後讓內嵌 FAQPage 自帶 SEO 接管 */}
      {isPreviewRoute && (
        <Helmet>
          <meta name="robots" content="noindex,follow" />
          <link rel="canonical" href={canonicalUrl} />
        </Helmet>
      )}
      <div className="min-h-screen bg-[#f5f1ea]">
        <HeaderV2 />
        <FunctionalHeroV2
          eyebrow={isEn ? 'Help Center' : '說明中心'}
          title={isEn ? 'FAQ' : '常見問題'}
          subtitle={
            isEn
              ? 'Answers to questions about products, orders, shipping, and after-sales support.'
              : '關於商品、訂單、配送與售後支援的常見疑問解答。'
          }
          backgroundImage="https://images.pexels.com/photos/302899/pexels-photo-302899.jpeg?auto=compress&cs=tinysrgb&w=1920"
          breadcrumbs={[
            { label: isEn ? 'Home' : '首頁', to: `/${lang}` },
            { label: isEn ? 'FAQ' : '常見問題' },
          ]}
          height="h-[420px] md:h-[500px]"
        />
        <main
          className="bg-[#f5f1ea]"
          style={{ fontFamily: "'EB Garamond', 'Noto Serif TC', serif" }}
        >
          <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-16 md:py-24">
            <FAQPage />
          </div>
        </main>
        <FooterV2 />
      </div>
    </>
  );
}
